import React from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter, Route, Switch } from "react-router-dom"

import "@/_styles/index.scss"

import { setNavigationRef } from "@/_services/utils"
import { setupAxiosClient } from "@/_services/axios"
import { register as registerServiceWorker } from "@/_services/serviceWorker"
import App from "@/App.js"

// temporary ignore warnings from outdated react-bootstrap until we migrated
const originalError = console.error
const warningsBypassed = ["ReactDOM.unstable_renderSubtreeIntoContainer", "uses the legacy childContextTypes API", "uses the legacy contextTypes API"]
console.error = function (...args) {
  if (typeof args[0] === "string" && warningsBypassed.some(el => args[0].includes(el))) {
    return // suppress the warning
  }
  originalError.apply(console, args)
}

const onReady = () => {
  const rootEl = document.getElementById("root")
  const root = createRoot(rootEl)

  root.render(
    <BrowserRouter ref={setNavigationRef}>
      <Switch>
        <Route path="/" component={App} />
      </Switch>
    </BrowserRouter>,
  )
}

setupAxiosClient(window.location.origin)
registerServiceWorker({ onReady })
